// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"index__toolbar___PkgVZ","inner":"index__inner___2TtFW","contextual":"index__contextual___BSxNM"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/skin/styles/toolbar/index.css
// module id = 1239
// module chunks = 0